export default "__VITE_ASSET__B14I77E2__"